import type { ReactNode } from 'react';

import { Card, Skeleton } from '@/design-system';
import { ErrorState } from '@/shared/ui';

import { adminCopy } from '../copy';

export interface AdminRegionProps {
    title: string;
    query: { isPending: boolean; isError: boolean; error: unknown; refetch: () => unknown };
    skeletonHeight?: number;
    errorTitle?: string;
    children: ReactNode;
}

/**
 * Elke kaart wacht voor zichzelf: laden, een fout met "Opnieuw proberen", of de
 * inhoud. Eén trage query houdt de rest van het scherm niet tegen.
 */
export function AdminRegion({
    title,
    query,
    skeletonHeight = 120,
    errorTitle,
    children,
}: AdminRegionProps) {
    if (query.isPending) {
        return (
            <Card padding="md" aria-busy="true">
                <Skeleton height={skeletonHeight} pulse label={adminCopy.loading(title)} />
            </Card>
        );
    }

    if (query.isError) {
        return (
            <Card padding="md">
                <ErrorState
                    error={query.error}
                    title={errorTitle ?? title}
                    onRetry={() => void query.refetch()}
                />
            </Card>
        );
    }

    return <>{children}</>;
}
